export default {
  vehicle_passport: {
    title: 'ПТС',
    editComponent: 'DocumentVehiclePassportEdit',
    viewComponent: 'DocumentVehiclePassportView',
    tabs: { title: 'ПТС', scansTittle: 'Сканы ПТС' }
  },
  osago: {
    title: 'ОСАГО',
    editComponent: 'DocumentOsagoEdit',
    viewComponent: 'DocumentOsagoView',
    tabs: { title: 'ОСАГО', scansTittle: 'Сканы ОСАГО' }
  },
  sts: {
    title: 'СТС',
    editComponent: 'DocumentStsEdit',
    viewComponent: 'DocumentStsView',
    tabs: { title: 'СТС', scansTittle: 'Сканы СТС' }
  },
  pass_carriage_licence: {
    title: 'Разрешение на перевозку',
    editComponent: 'DocumentPassCarriageLicenceEdit',
    viewComponent: 'DocumentPassCarriageLicenceView',
    tabs: { title: 'Разрешение на перевозку', scansTittle: 'Сканы разрешения' }
  }
}
